import { ChartLayoutConfig, Company } from "./company.model";
import { SurveyEvent } from "./survey.event.model";

export interface ClaimUser {
  username: string;
  name: string;
  email: string;
  role: UserTypeEnum;
  picture?: string;
  emailVerified: boolean;
  companyId: string;
  company?: Company;
  allowedHierarchies?: string[];
  chartConfig?: ChartLayoutConfig | null;
  surveyEvents?: SurveyEvent[];
}

export enum UserTypeEnum {
  "root" = "root",
  "admin" = "admin",
  "viewer" = "viewer",
}

export function checkIfHasPermission(
  loggedUser?: ClaimUser,
  roles?: UserTypeEnum[]
) {
  if (!roles) {
    return true;
  }
  if (!loggedUser) {
    return false;
  }
  return roles.includes(loggedUser.role);
}
